import { PawPrint, BadgeCheck, Heart, Star } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

const verifiedShelters = [
  { name: "KTOZ Kraków", city: "Kraków" },
  { name: "Schronisko LPGK Legnica", city: "Legnica" },
  { name: "Koci Azyl Żagań", city: "Żagań" },
  { name: "Schronisko Kielce", city: "Kielce" },
  { name: "Schronisko Piotrków Tryb.", city: "Piotrków Tryb." },
  { name: "Schronisko Kiczarów", city: "Stargard" },
  { name: "Schronisko Chełm", city: "Chełm" },
  { name: "Schronisko Milanówek", city: "Milanówek" },
  { name: "Schronisko Borek", city: "Rzezawa" },
  { name: "Schronisko Ciapek", city: "Hajnówka" },
  { name: "Schronisko Sokółka", city: "Sokółka" },
  { name: "Jedno Serce Nie Da Rady", city: "Szumowo" },
];

export const InstagramStory12Verified3 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: 0,
        }}
      />

      {/* Accent bar at top */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "6px",
          background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 33%, #4E8A6E 66%, #6BAF8D 100%)",
          zIndex: 3,
        }}
      />

      {/* Safe zone content */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          padding: "280px 50px 280px",
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* Header - celebratory style */}
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <div style={{ display: "flex", justifyContent: "center", gap: "16px", marginBottom: "8px" }}>
            <Star style={{ width: "32px", height: "32px", color: "#F4C430", fill: "#F4C430" }} />
            <Star style={{ width: "32px", height: "32px", color: "#F4C430", fill: "#F4C430" }} />
            <Star style={{ width: "32px", height: "32px", color: "#F4C430", fill: "#F4C430" }} />
          </div>
          <h1 style={{ fontSize: "50px", fontWeight: 800, color: "#2D5A3D", margin: 0, lineHeight: 1.1 }}>
            Już <span style={{ color: "#4E8A6E", fontSize: "64px" }}>12</span> schronisk
          </h1>
          <p style={{ fontSize: "38px", fontWeight: 700, color: "#4A7A5E", margin: "8px 0 0" }}>
            zweryfikowało profil! 🎉
          </p>
        </div>

        {/* Shelter cards - compact list */}
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {verifiedShelters.map((shelter, i) => (
            <div
              key={i}
              style={{
                background: "rgba(255,255,255,0.97)",
                borderRadius: "18px",
                padding: "18px 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                boxShadow: "0 3px 12px rgba(0,0,0,0.05)",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
                <BadgeCheck style={{ width: "28px", height: "28px", color: "#4E8A6E", flexShrink: 0 }} />
                <span style={{ fontSize: "26px", fontWeight: 700, color: "#2D5A3D" }}>
                  {shelter.name}
                </span>
              </div>
              <span style={{ fontSize: "22px", fontWeight: 600, color: "#6B8A7A" }}>
                📍 {shelter.city}
              </span>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "rgba(229,115,115,0.15)",
              borderRadius: "100px",
              padding: "16px 36px",
              marginBottom: "20px",
            }}
          >
            <Heart style={{ width: "28px", height: "28px", color: "#E57373", fill: "#E57373" }} />
            <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>
              Pomóż im teraz!
            </span>
          </div>

          {/* Logo */}
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
            <div
              style={{
                background: "#4E8A6E",
                borderRadius: "14px",
                width: "44px",
                height: "44px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <PawPrint style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
            </div>
            <span style={{ fontSize: "30px", fontWeight: 800, color: "#2D5A3D" }}>
              GdzieSchronisko.pl
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
